import Ajax from "DMS/Seed/Seed.Ajax";
import Import from "DMS/Seed/Seed.Import";
import Interface from "DMS/Seed/Seed.Interface";
import Menu from "DMS/Seed/Seed.Menu";
import Page from "DMS/Seed/Seed.Page";
import Planning from "DMS/Seed/Seed.Planning";
import Tab from "DMS/Seed/Seed.Tab";
import Form from "DMS/Seed/Seed.Form";
export default {
    Ajax: Ajax,
    Import: Import,
    Interface: Interface,
    Menu: Menu,
    Page: Page,
    Planning: Planning,
    Tab: Tab,
    Form: Form
};
//# sourceMappingURL=All.js.map